// Components
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'
import { nothing } from '$func/utils'
import { useState, useLayoutEffect } from 'react'
import { BottomDrawer } from '$common/bottom-drawer'

interface Prop {
  children: ReactJSXElement[]
}

export function AuthContainer({ children }: Prop) {
  const [isOpen, setIsOpen] = useState(false)

  useLayoutEffect(() => {
    setIsOpen(true)
  }, [])

  return (
    <BottomDrawer
      isOpen={isOpen}
      variant="persistent"
      onClose={nothing}
      sx={{ width: '100%' }}
      paperProps={{ sx: { padding: '0 16px 32px 16px' } }}
    >
      {children}
    </BottomDrawer>
  )
}
